import { writable } from 'svelte/store';
import Cookies from 'js-cookie'

function createStore() {
  const { subscribe, set, update } = writable(Cookies.get());

  return {
    subscribe,
    update,
    set,
    reset: () => set(Cookies.get())
  };
}

const cookieStore = createStore();

export default cookieStore;
